import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, InputGroup, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

const FormularioRegistroLead = ({ cargando, onSubmit }) => {
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const handleFormSubmit = (data) => {
        onSubmit(data);
        setValue("vTelefonoLead", "");
    };

    return (
        <Col xs={12} md={5} lg={4}>
            <span>#Tel. del contacto / Lead: </span>
            <Form noValidate onSubmit={handleSubmit(handleFormSubmit)}>
                <InputGroup className="fs--1 align-items-center">
                    <Form.Control
                        type="text"
                        size="sm"
                        disabled={cargando}
                        autoComplete="off"
                        isInvalid={!!errors.vTelefonoLead}
                        {...register("vTelefonoLead", {
                            required: 'Este campo es requerido, incluya el código de pais: ejemplo: +52',
                            maxLength: 20,
                            minLength: 10,
                            pattern: {
                                value: /^[+][ 0-9()-]+$/,
                                message: "Teléfono incorrecto. Debe iniciar con el prefijo: +"
                            }
                        })}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.vTelefonoLead && errors.vTelefonoLead.message}
                    </Form.Control.Feedback>
                    <Button
                        disabled={cargando}
                        className="btn btn-primary"
                        size="sm"
                        type="submit"
                    >
                        Registrar
                    </Button>
                </InputGroup>
            </Form>
        </Col>
    );
};

FormularioRegistroLead.propTypes = {
    cargando: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default FormularioRegistroLead;
